import { useMemo } from 'react';

import { CertificateType, ContentLockSettings, Maybe, PerformanceStatusEnum } from '@/types/schema';

import { CoursePerformanceFragment } from '../../../graphql/fragments/generated/CoursePerformance';

const useResourcePerformanceResponse = (
  entityId: string = 'entityId',
  resources:
    | Record<
        string,
        CoursePerformanceFragment & {
          recalibrationRequired?: boolean;
          lockSettings?: Maybe<ContentLockSettings[]>;
        }
      >
    | undefined,
) => {
  const resourcePerformance = useMemo(() => {
    if (resources) return resources[entityId];
  }, [entityId, resources]);

  return useMemo(() => {
    if (!resourcePerformance || typeof resourcePerformance !== 'object') return undefined;
    return {
      isOverdue: resourcePerformance.status === PerformanceStatusEnum.Overdue,
      issuedCertificate: resourcePerformance.issuedCertificate as CertificateType | undefined,
      isStarted: resourcePerformance.status !== PerformanceStatusEnum.NotStarted,
      progress: resourcePerformance.progress,
      courseCompleted: resourcePerformance.progress === 100,
      status: resourcePerformance.status,
      resume: resourcePerformance.resume,
      recalibrationRequired: resourcePerformance?.recalibrationRequired,
    };
  }, [resourcePerformance]);
};

export default useResourcePerformanceResponse;
